import { fetcher } from '@commenda/utils';

import { CreateSupportIssueProps, TCreateSupportIssueResult } from './types';

export async function createSupportIssue(
  body: CreateSupportIssueProps,
  token?: string
): Promise<TCreateSupportIssueResult> {
  try {
    const response = await fetcher(
      'pylon/support-issue',
      { method: 'POST', body },
      token
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      return {
        success: false,
        error: errorData.message || 'Failed to submit your support request',
      };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to submit your support request';
    return { success: false, error: errorMessage };
  }
}
